<template>
    <ContentPage title="Политика конфиденциальности" sub-title="В соответствии со ст. 13 Регламента (ЕС) 2016/679">
        <p>
            Adorea S.r.l. (Fleequid), с юридическим адресом: Via provinciale per Bizzarone, 43 – 22077 Olgiate Comasco (CO), ИНН и налоговый код
            04114790134, зарегистрированная в Торговом реестре Комо под номером 04114790134, уставный капитал 10.000,00€ о.в. («
            <strong>Adorea S.r.l. (Fleequid)</strong>») в качестве оператора персональных данных настоящим информирует Вас об обработке Ваших
            персональных данных в соответствии со ст. 13 Регламента (ЕС) № 2016/679 («<strong>GDPR</strong>»).
        </p>

        <BaseVerticalStack as="ol" class="list-inside list-decimal">
            <li>
                <h3 class="text-highlighted inline-block font-bold">Цель обработки и правовое основание</h3>
                <p class="my-4">
                    Adorea S.r.l. (Fleequid) — это компания, занимающаяся управлением онлайн-аукционами промышленных транспортных средств,
                    предназначенными для корпоративных клиентов. Когда компания регистрируется на Adorea S.r.l. (Fleequid) для участия в аукционе, ей
                    будет предложено указать некоторые данные соответствующего контактного лица, а именно: имя, фамилию, адрес электронной почты и
                    номер телефона («<strong>Данные</strong>»). Эти данные будут обработаны Adorea S.r.l. (Fleequid), в том числе с помощью
                    электронных/цифровых средств, исключительно в следующих целях и на следующих правовых основаниях:
                </p>
                <div class="my-4 grid grid-cols-[40px_1fr_1fr] grid-rows-[24px_1fr_1fr] gap-2">
                    <div class="font-bold">№</div>
                    <div class="font-bold">Цель</div>
                    <div class="font-bold">Правовое основание</div>
                    <div class="font-bold">1.1</div>
                    <div>
                        Обеспечение участия в аукционе по запросу пользователя, гарантирование его нормального проведения и возможности связаться с
                        контактным лицом компании в случае присуждения
                    </div>
                    <div>Исполнение договора</div>
                    <div class="font-bold">1.2</div>
                    <div>Отправка информационных материалов об услугах Adorea S.r.l. (Fleequid)</div>
                    <div>
                        Законный интерес на основании ст. 130, п. 4, d.lgs. 196/2003. Субъект данных может в любой момент возразить против обработки
                        простым и бесплатным способом.
                    </div>
                </div>
                <p class="my-4">
                    Предоставление Персональных данных необходимо для участия в аукционе и использования услуг Adorea S.r.l. (Fleequid), и их
                    непредоставление помешало бы такому участию и установлению договорных отношений с Adorea S.r.l. (Fleequid).
                </p>
            </li>
            <li>
                <h3 class="text-highlighted inline-block font-bold">Передача и трансфер Данных</h3>
                <p class="my-4">
                    Данные также могут обрабатываться компаниями-подрядчиками, которые осуществляют связанную, вспомогательную или поддерживающую
                    деятельность по отношению к деятельности Adorea S.r.l. (Fleequid) и которых Adorea S.r.l. (Fleequid) может привлекать для
                    выполнения вышеуказанных целей. Они будут действовать в качестве обработчиков данных в соответствии с инструкциями Adorea S.r.l.
                    (Fleequid). В случае если при обмене информацией Данные передаются в страны за пределами Европейского экономического пространства,
                    Adorea S.r.l. (Fleequid) обеспечит передачу Данных в соответствии с настоящей политикой конфиденциальности и применимым
                    законодательством о защите данных.
                </p>
            </li>
            <li>
                <h3 class="text-highlighted inline-block font-bold">Хранение Данных</h3>
                <p class="my-4">
                    Ваши Данные будут храниться в течение времени, строго необходимого для выполнения целей, указанных в пункте 1 выше, то есть 10 лет
                    с момента прекращения действия договора. Этот срок хранения обоснован, в части маркетинговых целей, особым характером товаров,
                    являющихся предметом аукционов, управляемых Adorea S.r.l. (Fleequid), а именно промышленных транспортных средств высокой
                    стоимости. По истечении этого срока Данные будут удалены или обезличены.
                </p>
            </li>
            <li>
                <h3 class="text-highlighted inline-block font-bold">Права субъекта данных</h3>
                <p class="my-4">
                    Вы можете в любой момент воспользоваться правом доступа к своим собственным Данным и следующей информации: цель обработки;
                    категории затронутых персональных данных; получатели или категории получателей, которым могут быть переданы данные; по
                    возможности, срок хранения данных в соответствии со ст. 15 GDPR; право на исправление неточных персональных данных в соответствии
                    со ст. 16 GDPR; право на удаление касающихся вас данных при соблюдении условий ст. 17 GDPR; право требовать ограничения обработки
                    при соблюдении условий ст. 18 GDPR; право на переносимость данных при соблюдении условий ст. 20 GDPR; право возражать против
                    обработки, включая обработку в маркетинговых целях, при соблюдении условий ст. 21 GDPR. Вы также всегда можете подать жалобу в
                    Орган по защите персональных данных в соответствии с порядком, указанным на сайте
                    <NuxtLink class="text-primary hover:underline" to="https://www.garanteprivacy.it" target="_blank" external>
                        www.garanteprivacy.it</NuxtLink
                    >.
                </p>
                <p class="my-4">
                    Для запросов или вопросов относительно наших практик в области конфиденциальности, пожалуйста, свяжитесь с нами по адресу
                    <FleequidEmailLink type="privacy" />. Мы отвечаем на все запросы пользователей, желающих воспользоваться своими правами в области
                    защиты персональных данных в соответствии с действующим законодательством о защите данных.
                </p>
            </li>
        </BaseVerticalStack>
    </ContentPage>
</template>
